import { CommonModule } from "@angular/common";
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgModule } from "@angular/core";

import { AppMaterialModule } from '../../../app/layouts/material/app.material.module';
import { AppShareModule } from "src/shared/app.module";
import { CaseAdditionalFilesComponent } from "../casefiles/crud/case-additional-files/case-additional-file.component";
import { CaseAdditionalFilesDataService } from "../../_dataservices/CaseAdditionalFilesDataService";
import { CaseDataService } from "../../_dataservices/CaseDataService";
import { CaseDetailComponent } from './detail/case-detail.component';
import { CaseFinalStepComponent } from './crud/case-final-step/case-final-step.component';
import { CaseListComponent } from './list/case-list.component';
import { CaseRoutingModule } from "./case.routing.module";
import { CaseServicesComponent } from './detail/case-services/case-services.component';
import { CaseStagesComponent } from './detail/case-stages/case-stages.component';
import { ConfirmCaseStepComponent } from "./crud/confirm-step/confirm-case-step.component";
import { CrudCaseComponent } from './crud/crud-case.component';
import { CrudCaseFileComponent } from "../casefiles/crud/crud-casefile.component";
import { CrudSetupComponent } from "../setups/crud/crud-setup.component";
import { CustomerDataService } from "../../_dataservices/CustomerDataService";
import { PipesModule } from '../../_appCommon/pipes/pipes.module';
import { PrescriptionModule } from '../prescriptions/prescription.module';
import { ProductModule } from "../products/product.module";
import { ShareModule } from '../../_appCommon/share.module';
import { CasePrescriptionsComponent } from "./detail/case-prescriptions/case-prescriptions.component";
import { StatusDataService } from "src/app-client/_dataservices/StatusDataService";
import { CaseListHomeComponent } from "src/app-client/home/cases/case-list-home/case-list-home.component";
import { CaseFilesManagerComponent } from "../case-files-manager/case-files-manager.component";
import { OrderDataService } from "src/app-client/_dataservices/OrderDataService";
import { OrderHistoryDataService } from "src/app-client/_dataservices/OrderHistoryDataService";
import { FileCorrectionComponent } from './file-correction/file-correction/file-correction.component';

@NgModule({
  declarations: [
    CaseAdditionalFilesComponent,
    CaseDetailComponent,
    CaseFinalStepComponent,
    CaseListComponent,
    CaseServicesComponent,
    CaseStagesComponent,
    ConfirmCaseStepComponent,
    CrudCaseComponent,
    CrudCaseFileComponent,
    CrudSetupComponent,
    CaseServicesComponent,
    CaseFinalStepComponent,
    CaseAdditionalFilesComponent,
    CasePrescriptionsComponent,
    CaseListHomeComponent,
    CaseFilesManagerComponent,
    FileCorrectionComponent
  ],
  exports: [
    CaseListComponent,
    CaseListHomeComponent
  ],
  imports: [
    CommonModule,
    CaseRoutingModule,
    FormsModule,
    ReactiveFormsModule,
    ShareModule,
    AppShareModule,
    ProductModule,
    AppMaterialModule,
    PipesModule,
    PrescriptionModule,
  ],
  providers: [
    CaseDataService,
    CustomerDataService,
    CaseAdditionalFilesDataService,
    StatusDataService,
    OrderDataService,
    OrderHistoryDataService
  ]
})

export class CaseModule { }
